var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMakaiLogoKo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 40",
    style: {
      enableBackground: "new 0 0 160 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5DBDC1;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.6,20.6c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S68.7,20.6,66.6,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.6,20.6c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S131.7,20.6,129.6,20.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.7,13.1c-2.4-2.1-5.5-3.4-9.2-3.4c-8.2,0-14.2,6.1-14.2,14.7c0,8.3,5.7,14.7,14.2,14.7 c3.5,0,6.7-1.3,9.2-3.4l0.3,2.8h6.6V10.3H138L137.7,13.1z M129.6,31.9c-4.4,0-7.5-3.1-7.5-7.6s3.1-7.6,7.5-7.6 c4.3,0,7.5,3.1,7.5,7.6S133.9,31.9,129.6,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.2,7.6c2.1,0,3.8-1.7,3.8-3.8S158.3,0,156.2,0s-3.8,1.7-3.8,3.8S154.1,7.6,156.2,7.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.4,
    y: 10.3,
    className: "st1",
    width: 7.6,
    height: 28.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.1,9.7c-4.2,0-7.6,1.6-10.2,4.8c-1.7-3.1-4.7-4.8-8.8-4.8c-3.6,0-6.7,1.4-8.7,3.8l-0.2-3.3H0v28.2h7.6V22.9 c0-3.7,2.4-6.2,6.3-6.2c3.5,0,5.3,2.2,5.3,6.2v15.5h7.6V22.9c0-3.7,2.4-6.2,6.3-6.2c3.5,0,5.3,2.2,5.3,6.2v15.5H46V22.1 C45.9,14.1,42.2,9.7,35.1,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.8,13.1c-2.4-2.1-5.5-3.4-9.2-3.4c-8.2,0-14.2,6.1-14.2,14.7c0,8.3,5.7,14.7,14.2,14.7 c3.5,0,6.7-1.3,9.2-3.4l0.3,2.8h6.6V10.3H75L74.8,13.1z M66.6,31.9c-4.4,0-7.5-3.1-7.5-7.6s3.1-7.6,7.5-7.6c4.3,0,7.5,3.1,7.5,7.6 S70.9,31.9,66.6,31.9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "97,19.7 97,1.2 89.4,1.2 89.4,38.5 97,38.5 97,28.8 105.3,38.5 113.1,38.5 113.1,37.1 102,24.3  102,24.3 113.1,11.5 113.1,10.3 105.1,10.3 97,19.7 97,28.8  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakaiLogoKo);
export default __webpack_public_path__ + "static/media/makai-logo-ko.869feec51e68288709ffab12045676ce.svg";
export { ForwardRef as ReactComponent };